import type { BlockMentionValues } from '@root/helpers/blocks/get-block-mention-values';

import { renderScheduleMentionValue } from './render-schedule-mention-value';

/**
 * The generic `getMentionValues` treats every linked datapoint's value as a primitive and
 * stringifies it — fine for scalar fields, but a schedule's value is a tree, so it needs its
 * own HTML rendering, merged in afterwards the same way `getClausesAsMentions` overrides the
 * generic (also-inapplicable) value for derived-content mentions.
 */
export const getScheduleMentionValues = (dataItems: unknown, linkedDatapointIds: string[]): BlockMentionValues => {
  return linkedDatapointIds.reduce<BlockMentionValues>((acc, id) => {
    const value = renderScheduleMentionValue(dataItems, id);

    return value === null ? acc : { ...acc, [id]: value };
  }, {});
};
